<ng-container *ngIf="faq$ | async as faq">
  <myclubrewards-editable-card-header
    [config]="faq"
  ></myclubrewards-editable-card-header>

  <ng-container *ngIf="faq.categories.length">
    <!-- <div class="faq-back-wrapper"> -->
    <div class="faq-elements-wrapper">
      <div class="faq-back"></div>
      <div class="faq-question">
        <myclubrewards-faq-category
          *ngFor="let category of faq.categories"
          [category]="category"
        ></myclubrewards-faq-category>
      </div>
    </div>
    <!-- </div> -->
  </ng-container>
</ng-container>
